import { Entity } from '@/store/shared/entity'
export default class Element extends Entity<number>{
    customsclearanceid:number;
    elementNo:number;
    element:string;
}
